import React, { useRef, useState } from "react";
import { Button, ButtonGroup, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ValuationType } from "common/types/common.types";

interface CreateValuationButtonProps {}

export const CreateValuationButton: React.FC<
  CreateValuationButtonProps
> = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const anchorRef = useRef<HTMLDivElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const secondaryActions = [
    {
      label: t("propertyList.createSimpleValuation"),
      to: "/properties/create/simple",
    },
    {
      label: t("propertyList.createLocationCheck"),
      to: `/properties/create/simple?valuationType=${ValuationType.LocationCheck}`,
    },
  ];

  return (
    <>
      <ButtonGroup
        variant="contained"
        ref={anchorRef}
        sx={{
          // Match the theme's button radius so the group's own shadow does not
          // show square corners behind the rounded buttons.
          borderRadius: "10px",
          "& .MuiButtonGroup-grouped:not(:last-of-type)": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
          "& .MuiButtonGroup-grouped:not(:first-of-type)": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
        }}
      >
        <Button onClick={() => navigate("/properties/create/inputMethod")}>
          {t("propertyList.createValuation")}
        </Button>
        <Button
          size="small"
          aria-label={t("propertyList.moreValuationActions")}
          aria-haspopup="menu"
          aria-expanded={isMenuOpen}
          onClick={() => setIsMenuOpen(true)}
          sx={{ minWidth: "40px", paddingX: 0 }}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Menu
        anchorEl={anchorRef.current}
        open={isMenuOpen}
        onClose={() => setIsMenuOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        {secondaryActions.map((action) => (
          <MenuItem
            key={action.to}
            onClick={() => {
              setIsMenuOpen(false);
              navigate(action.to);
            }}
          >
            {action.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
